import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { unlock_feature } from "../../../Controllers/FeatureLock";
import toast from "react-hot-toast";
import { get_all_sub_branches } from "../../../Controllers/Settings/Branches";

const FeatureUnlockModal = ({
  isOpen,
  onClose,
  feature,
  onSuccess
}) => {
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [transactionId, setTransactionId] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [featureData, setFeatureData] = useState(null);
  const [subBranches, setSubBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [lockedBranches, setLockedBranches] = useState([]);


  const fetchAllsubBranches = async () => {
    try {
      const response = await get_all_sub_branches();
      if (response?.status) {
        const branches = response?.data?.data || [];
        setSubBranches(branches);
      } else {
        toast.error("Failed to load features");
      }
    } catch (error) {
      toast.error("Error loading features");
    }
  };


  useEffect(() => {
    if (feature) {
      setFeatureData(feature);
      setLockedBranches(feature.lockedBranches || []);
    }
    fetchAllsubBranches()
  }, [feature]);

  const handleUnlock = async () => {

    if (!featureData || !featureData._id) {
      toast.error("Feature information is missing");
      return;
    }

    if (!selectedBranch) {
      toast.error("Please select a branch to unlock");
      return;
    }

    try {
      setIsProcessing(true);

      const response = await unlock_feature({
        feature_id: featureData._id,
        branch_id: selectedBranch,
        payment_method: paymentMethod,
        transaction_id: transactionId,
        amount: featureData.standalone_amount
      });

      console.log("Unlock response:", response);

      if (response?.status) {
        toast.success(`Successfully unlocked "${featureData.name}"!`);
        if (onSuccess) onSuccess();
        if (onClose) onClose();
      } else {
        toast.error(response?.message || "Failed to unlock feature");
      }
    } catch (error) {
      console.error("Unlock feature error:", error);
      toast.error("An error occurred while unlocking the feature");
    } finally {
      setIsProcessing(false);
    }
  };

  if (!featureData) {
    return null;
  }



  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      title={`Unlock: ${featureData.name}`}
      footer={null}
      centered
    >
      <div className="p-1">
        <div className="mb-4 p-4 bg-blue-50 rounded-lg">
          <p className="text-sm text-blue-800 mb-2">
            {featureData.description || "Unlock this premium feature"}
          </p>
          <p className="text-lg font-semibold text-blue-900">
            Amount: {featureData.standalone_amount?.toFixed(2) || "0.00"}
          </p>
          {featureData.duration_days > 0 && (
            <p className="text-sm text-blue-700 mt-1">
              Valid for {featureData.duration_days} days
            </p>
          )}
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Payment Method
            </label>
            <select
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <option value="cash">Cash</option>
              <option value="card">Credit/Debit Card</option>
              <option value="bank_transfer">Bank Transfer</option>
              <option value="cheque">Cheque</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Select Sub Branch
            </label>

            <select
              className="w-full px-3 py-2 border border-gray-300 rounded-md
   focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedBranch}
              onChange={(e) => setSelectedBranch(e.target.value)}
            >
              <option value="">-- Select Sub Branch --</option>

              {lockedBranches.map((branch) => (
                <option key={branch.branch_id} value={branch.branch_id}>
                  {branch.branch_name}
                </option>
              ))}
            </select>

          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Transaction ID/Reference
            </label>
            <input
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter transaction reference"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              required
            />
            <p className="text-xs text-gray-500 mt-1">
              Please provide the payment transaction reference
            </p>
          </div>

          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-colors"
              onClick={onClose}
              disabled={isProcessing}
            >
              Cancel
            </button>
            <button
              type="button"
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              onClick={handleUnlock}
              disabled={isProcessing}
            >
              {isProcessing ? "Processing..." : "Unlock Feature"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FeatureUnlockModal;